export const path = {
  site: 'https://my.journeyeasy.net/'
}